module.exports = __webpack_public_path__ + "img/13.4febf0d4.jpg";